<template>
  <v-autocomplete
    color="primary"
    v-model="stockPositionSelected"
    :clearable="!unclearable"
    :items="stockPositionItems"
    :loading="stockPositionLoading"
    :search-input.sync="stockPositionSearch"
    item-value="id"
    item-text="Description"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('Position.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    @change="$emit('changed',stockPositionSelected)"
  >
  </v-autocomplete>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "SearcherMovePosition",

  props: {
    value: Object,
    stock: Object,
    stockPositions: Array,
    dense: Boolean,
    noLabel: Boolean,
    label: String,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
    stockPositionItems() {
      return this.stockPositions.map((position) => {
        var Description = i18n.t("MovePositionOrder.DetailFields.position", [
          position.position_code,
          position.position_name,
        ]);
        if (this.stock && this.stock.position_name_display) {
          if (this.stock.position_name_display.indexOf(2) > -1) {
            Description = position.position_name;
          }
          if (
            this.stock.position_name_display.indexOf(4) > -1 &&
            position.roadway_code
          ) {
            Description = position.roadway_code + " - " + Description;
          }
          if (
            this.stock.position_name_display.indexOf(3) > -1 &&
            position.area_name
          ) {
            Description = position.area_name + " - " + Description;
          }
        }
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.position_id == position.id
            )
          : false;
        return Object.assign({}, position, { Description, disabled });
      });
    },
  },

  data: () => ({
    stockPositionLoading: false,
    stockPositionSearch: "",
    stockPositionSelected: [],
  }),


  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockPositionSelected = this.value;
      },
    },
    stockPositionSelected: {
      handler() {
        this.$emit("input", this.stockPositionSelected);
      },
    },
  },
};
</script>